import { Popover } from '@chakra-ui/react';
import { FilterPopoverButton, FilterPopoverContent } from './FilterPopover';
import { CheckboxFilter } from './CheckboxFilter';
import { ICourse } from '@/shared/ICourse';
import { naturalComparer } from '@/shared/parse';
import React from 'react';


export const CheckboxFilterProvider = (props: {
  allCourses: ICourse[];
  value: string[] | undefined;
  onSetFilter: (value: string[] | undefined) => void;
}) => {

  const getProviderTitle = (provider: { ProviderIdentifier: string; ProviderName: string }) => 
    `${provider.ProviderIdentifier} | ${provider.ProviderName}`;

  const options = React.useMemo(() => {
    // Collect all existing providers from courses
    const providerCounts = new Map<string, { provider: { id: string; ProviderIdentifier: string; ProviderName: string }, count: number }>();
    
    props.allCourses?.forEach(course => {
      if (course.provider && course.providerId && course.provider.ProviderIdentifier && course.provider.ProviderName) {
        const existing = providerCounts.get(course.providerId);
        if (existing) {
          existing.count++;
        } else {
          providerCounts.set(course.providerId, {
            provider: { id: course.providerId, ProviderIdentifier: course.provider.ProviderIdentifier, ProviderName: course.provider.ProviderName },
            count: 1
          });
        }
      }
    });

    return Array.from(providerCounts.values())
      .map(({ provider, count }) => ({
        label: getProviderTitle(provider),
        value: provider.id,
        count
      }))
      .sort((a, b) => naturalComparer.compare(a.label, b.label));
  }, [props.allCourses]);

  const hasSelection = props.value !== undefined && props.value.length > 0;

  return (
    <Popover isLazy placement="bottom-start">
      <FilterPopoverButton label="Provider" selected={hasSelection} />
      <FilterPopoverContent>
        <CheckboxFilter
          hideLabel
          showSearch
          value={props.value}
          onChange={(v) => props.onSetFilter(v)}
          options={options} />
      </FilterPopoverContent>
    </Popover>
  );
};
